import React from "react";
import "./idCard.css";
import { replacePlaceholders } from "../utils/replacePlaceholders";

interface IdCardRendererProps {
  templateHtml?: string;
  studentData?: any;
  orientation?: "landscape" | "portrait";
  backgroundImage?: string;
  html?: string; // Pre-rendered HTML option
}

const IdCardRenderer: React.FC<IdCardRendererProps> = ({
  templateHtml,
  studentData,
  orientation = "landscape",
  backgroundImage,
  html,
}) => {
  let content = html;

  if (!content && templateHtml && studentData) {
    content = replacePlaceholders(templateHtml, studentData);
  }

  if (!content) return null;

  // If html is provided, it might already contain the container. 
  // However, based on the prompt, we want the renderer to control the container.
  // We will assume 'content' is the INNER content (the placeholders replaced).
  // But if 'html' comes from backend 'getIdCardHtml', it is a full HTML document.
  // We need to handle that.
  
  const isFullHtml = content.trim().startsWith("<!DOCTYPE html") || content.includes("<html");
  
  if (isFullHtml) {
      // If it's full HTML, we just render it in an iframe or div, 
      // but for the purpose of this task (Unified Renderer), we prefer the inner content.
      // We will render it as is, assuming the backend did the right thing.
      return <div dangerouslySetInnerHTML={{ __html: content }} />;
  }

  return (
    <div
      className={`id-card-container ${orientation.toLowerCase()}`}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
      }}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default IdCardRenderer;
